import React, { useEffect } from 'react';
import styled from 'styled-components';
import { actions as personProfileActions } from 'Slice/PersonProfileSlice';
import { useDispatch, useSelector } from 'react-redux';
import {
  personVideos, selectVideoCall, selectVideoFlurry,
} from 'Selector/PersonProfileSelector';
import ArticleLoadingSkeletonBundle from 'Components/common/skeleton/ArticleLoadingSkeletonBundle';
import InfiniteScroll from 'react-infinite-scroll-component';
import { actions as helperActions } from 'Slice/HelperSlice';
import { valueToObject } from 'Utils/UtilityFunctions';
import ArticleListLoadingSkeletonBundle from 'Components/common/skeleton/ArticleListLoadingSkeletonBundle';
import { boxShadow, white } from 'Utils/utilsStyle';
import VideoGridLayout from 'Components/common/components/VideoGridLayout';
import NoUpdatesToShow from './NoUpdatesToShow';

const Wrapper = styled.div`
  padding: 24px 12px;
  background: ${white};
  box-shadow: ${boxShadow};
  border-radius: 16px;

  & .heading-inner-page{
    padding: 0 12px;
  }

  & .personVideosArticlesWrapper{

    .infiniteScrollWrapper{
      padding: 0 12px;
      padding-top: 20px;
    }
  }
`;

type Props = {
  personId: number;
  personType: string;
  listview: boolean;
} & typeof defaultProps;

const defaultProps = {
  listview: false,
};

const PersonVideos: React.FC<Props> = function PersonVideos({ personId, personType, listview }) {
  const dispatch = useDispatch();
  const {
    articles, loading, page,
  } = useSelector(personVideos);
  const flurryObject = useSelector(selectVideoFlurry);
  const isCalled = useSelector(selectVideoCall);

  useEffect(() => {
    if (Object.keys(flurryObject).length) {
      dispatch(helperActions.callFlurryEvent(
        valueToObject('person_video', 0, {
          ...flurryObject,
          isDeleteTime: true,
          ...isCalled && { isCalled },
        }),
      ));
      dispatch(personProfileActions.setVideoCall(true));
    }
  }, [flurryObject]);

  const loadMore = () => {
    if (!loading) {
      dispatch(personProfileActions.getPersonProfileVideos(
        {
          personId, type: personType, page: page + 1, videos: true,
        },
      ));
    }
  };

  return (
    <Wrapper>
      <div className="heading-inner-page">
        <h1 className="heading">
          Videos
        </h1>
      </div>
      {articles.length === 0 && !loading ? (
        <NoUpdatesToShow title="No updates to show" />
      )
        : (
          <div className="personVideosArticlesWrapper">
            <InfiniteScroll
              dataLength={articles.length}
              next={loadMore}
              hasMore
              loader={loading && (
                <div>
                  {listview ? (
                    <ArticleListLoadingSkeletonBundle />
                  ) : (
                    <ArticleLoadingSkeletonBundle />
                  )}
                </div>
              )}
              className="o-x-hidden o-y-hidden infiniteScrollWrapper"
            >

              <VideoGridLayout articlesArray={articles} listview={listview} />
            </InfiniteScroll>
          </div>
        )}
    </Wrapper>
  );
};

export default PersonVideos;
